import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b9d9d57d947e001447dc1b/incade/src/app/(public)/delete-my-data/page.tsx");
